<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">基金诊断服务协议</span>
      <Reback class="row-one-fr" @click.native="$router.push({name:'fundDiagnosisPay'})"></Reback>
    </el-row>
    <div class="margin-t30 server" style="margin-left: 30px; margin-right: 30px;height:600px;overflow:auto;">
      <div>特别提醒：在您确认签署本合同之前，请您务必仔细阅读本协议所有条款。一旦您签署本协议，即意味着您已充分理解本协议所有条款的含义及相应的法律后果，同意与本协议其他方以数据电文形式订立本合同并接受本协议约束。未满十八周岁者请勿开通本服务，若已经开通，展恒基金有权即时终止对您的服务。</div>
      <div>本《基金诊断服务协议》（以下简称“协议“）由您与北京展恒基金销售股份有限公司（以下简称”展恒基金“）于您在线确认时数据库记录的时间在北京市朝阳区签署：</div>
      <div style="margin-top:10px;text-indent:0px;color: #4293d2;"> 第一条 基本信息</div>
      <div>请关注以下基本信息要素，将有助于保障您的服务体验：</div>
      <div>为了保护您的个人信息，本协议在向您展示时将部分隐藏您的身份信息，您的身份信息详情以您在展恒基金平台注册开户时的个人信息为准。</div>
      <div>投资者姓名：<span>{{username}}</span></div>
      <div>身份证号码：<span>{{userno}}</span></div>
      <div>合同生效：本协议自您在线确认后即生效，但需要完成费用支付后展恒基金方可为您提供相应的服务。</div>
      <div></div>
      <div style="color: #4293d2;">第二条 服务内容</div>
      <div>展恒基金为您提供基金诊断服务，服务内容包括根据您提交的基金持仓信息，为您提供持仓分析并给出适当的投资建议，该项服务为展恒基金为您在基金投资过程中提供的一项增值服务。</div>
      <div style="color: #4293d2;">第三条 服务方式</div>
      <div>3.1您通过展恒基金平台（包括但不限于www.myfund.com、展恒基金网APP等）提交自己的基金持仓信息（基金数据不超过30只）；</div>
      <div>3.2您按照展恒基金平台公布的基金诊断服务价格，从以自己的名义开立的账户中成功完成在线支付；</div>
      <div>3.3展恒基金在收到您的服务费后，根据自身专业知识对您的基金持仓进行分析并提供基金诊断报告，诊断报告中的信息均来源于市场公开可获得的资料，且展恒基金对这些资料或数据的准确性、完整性和正确性不做任何保证和担保，不承担任何形式的连带责任；</div>
      <div>3.4您应对展恒基金提供的基金诊断报告中的意见或建议是否符合自身特定状况进行审慎评估，自行独立决定是否按照基金诊断报告的建议进行调整，并独立承担由此可能带来的不利后果和损失。</div>
      <div>3.5展恒基金通过展恒基金平台向您发出基金诊断报告即视为本协议约定的服务完成，本协议自动失效。</div>
      <div style="color: #4293d2;">第四条 承诺与保证</div>
      <div>4.1您保证是展恒基金平台的客户，已经如实填写了投资者信息表，并按照《证券期货投资者适当性管理办法》的要求完成了展恒基金平台的适当性管理流程；</div>
      <div>4.2您承诺在接受展恒基金提供的基金诊断报告后，独立自主的进行基金投资决策，基金投资产生的一切损失与展恒基金无关；</div>
      <div>4.3您承认基金诊断报告没有考虑到您特殊的投资目标、财务状况或需要。您应对基金诊断报告中的意见或建议是否符合其自身特定状况进行审慎评估，并独立承担由此可能带来的不利后果和损失；</div>
      <div>4.4您承认展恒基金未对您的投资本金及收益作出任何承诺和保证；</div>
      <div>4.5您承认基金诊断报告内容及其中可能出现的非展恒基金原因产生的任何错误、疏忽、误解或其他不确定之处，展恒基金不承担任何法律责任；</div>
      <div>4.6您保证知晓基金诊断服务为收费服务，并同意按照展恒基金平台公布的服务费价格及时支付服务费；</div>
      <div>4.7您承认在基金诊断服务费未成功支付之前，展恒基金有权不提供任何基金诊断服务；</div>
      <div>4.8本报告仅向接受服务的您发送，未经展恒基金授权许可，不得以任何方式复印、传送、分享或出版，否则您需承担可能产生的法律责任；</div>
      <div>4.9展恒基金根据法律法规及监管规定对您的信息承担保密义务，且法律法规及其他规范性文件、监管要求、相关信息已经公开、您同意无需严格保密、本协议另有约定及其他合法情形下除外。</div>
      <div style="color: #4293d2;">第五条 免责条款及故障条款</div>
      <div>5.1因下列原因导致展恒基金及为本协议所涉服务提供基础服务的支付渠道等（以下简称基础服务商）无法正常提供服务，展恒基金及基础服务商不承担任何责任：</div>
      <div>5.1.1展恒基金或基础服务商系统停机维护或升级；</div>
      <div>5.1.2因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；</div>
      <div>5.1.3您使用的电脑软硬件和通信线路、供电线路出现故障的；</div>
      <div>5.1.4您操作不当或通过非展恒基金授权或认可的方式使用展恒基金服务的；</div>
      <div>5.1.5因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。</div>
      <div>5.2尽管有前款约定，展恒基金将采取合理行动积极促使服务恢复正常。</div>
      <div>5.3本协议有效期内，因国家相关主管部门颁布、变更的法律、法规、规章、规定、指引、通知、政策及其他规范性文件等导致展恒基金不能提供约定服务的，不应视为违约，展恒基金可根据相关规定变更协议内容或者提前终止协议。</div>
      <div>5.4故障条款您理解本协议所涉及服务有赖于展恒基金及基础服务商系统的准确性运行及操作。若出现展恒基金系统差错、故障或其他原因引发了展示错误、您或展恒基金不当获利等情形的，您同意展恒基金可以自行或通过第三方采取更正差错、扣划款项、暂停服务等适当纠正措施。</div>
      <div style="color: #4293d2;">第六条 协议变更、解除和终止</div>
      <div>6.1协议变更与解除</div>
      <div>6.1.1展恒基金有权修改本协议中与您有关的权利义务，一旦协议条款变更，展恒基金将书面通知您，除法律法规或监管规定另有强制性规定外，经修订的内容一经通知，立即生效。若您不同意修改本协议，则应当自该等通知送达之日起立即停止本协议约定的服务；若您在修订生效后继续使用本服务的，视为您同意并接受修改后的协议。</div>
      <div>6.1.2本协议生效后，除本协议另有约定或双方协商确认外，您不得要求单方变更或解除本协议。展恒基金基于自身经营考虑，可通过展恒基金平台网上公示等通知送达方式提前宣布中断、终止本协议。</div>
      <div>6.2协议终止</div>
      <div>6.2.1本协议在展恒基金向您提供本协议所涉及基金诊断服务的报告后，自行终止。</div>
      <div style="color: #4293d2;">第七条 送达与管辖</div>
      <div>7.1送达</div>
      <div>7.1.1本协议履行过程中，展恒基金传送给您的书面通知，按照您向展恒基金提供的通讯地址快递后的第三个自然日即视为送达；书面通知的形式还包括在展恒基金平台公告、向您发送电子邮件、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下发送当日即视为送达。</div>
      <div>7.2管辖</div>
      <div>7.2.1本协议适用中华人民共和国法律。</div>
      <div>7.2.2凡因本协议产生的或与本协议有关的任何争议，双方应通过友好协商方式解决。双方未能通过协商方式解决的，任意一方均有权向北京仲裁委员会提起仲裁。</div>
      <div>7.2.3当产生任何争议及任何争议正按前条规定进行解决时，除争议事项外，双方可继续行使本协议项下的其他权利，并应继续履行本协议项下的其他权利、义务。如本协议中的任何条款被认定为全部或部分不合法、无效或不可强制执行，并不影响其他条款的有效和执行。</div>
    </div>
    <div style="margin:50px;text-align:center">
      <el-button type="normal" @click="$router.push({name:'fundDiagnosisPay'})">确认</el-button>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      username: '',
      userno: ''
    }
  },
  created () {
    this.username = Base64.decode(this.$commonJs.getCookie('u_name1'))
    this.userno = Base64.decode(this.$commonJs.getCookie('u_id'))
  }
}
</script>

<style lang="less" scoped>
.server {
  color: @color3;
  line-height: 30px;
}
.lm_transtitle_underline {
  width: 1145px;
  margin: 0 auto;
  height: 1px;
  background: #ccc;
}
</style>